export const BUILD_VERSION = 'deploy-20261026102514482';
